import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { CHART_TYPES } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { CHART_EVENTS } from "../constants/CrudChartConstants";
import draggable from "vuedraggable";

Vue.use(Vuetify);

@Component({
  name: "ChartTypeSelection",
  components: {
    draggable
  }
})
export default class ChartTypeSelection extends Vue {
  TOOLTIP = FORM_TEMP_CONSTANTS.TOOLTIP;
  CHAR_TYPES = CHART_TYPES;

  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;

  currentChartTypeIndex = 2;

  changeChartType(chartType: string) {
    this.$emit(CHART_EVENTS.CHANGE_CHART_TYPE, chartType);
  }
}
